import ReactMarkdown from "react-markdown";
import { FileText, Copy, Check } from "@phosphor-icons/react";
import { useState } from "react";
import { AgentAvatar } from "@/components/agent/AgentCard";

export const ChatMessage = ({ msg, agent, index }) => {
  const [copied, setCopied] = useState(false);
  if (msg.role === "user") {
    return (
      <div className="flex justify-end" data-testid={`chat-message-user-${index}`}>
        <div className="max-w-[85%] whitespace-pre-wrap bg-white/[0.06] px-4 py-3 text-sm leading-relaxed text-zinc-100">{msg.content}</div>
      </div>
    );
  }
  const copy = () => {
    navigator.clipboard.writeText(msg.content);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="group flex gap-3" data-testid={`chat-message-assistant-${index}`}>
      <AgentAvatar icon={agent?.icon} color={agent?.color} size={30} />
      <div className={`min-w-0 flex-1 border-l border-blue-500/60 pl-4 ${msg.streaming && !msg.content ? "thinking-beam" : ""}`}>
        {msg.error ? (
          <p className="text-sm text-red-400">{msg.error}</p>
        ) : (
          <div className={`md text-sm text-zinc-200 ${msg.streaming ? "cursor-block" : ""}`}>
            {msg.content ? <ReactMarkdown>{msg.content}</ReactMarkdown> : <span className="text-zinc-500">Pensando</span>}
          </div>
        )}
        {!msg.streaming && (msg.sources?.length > 0 || msg.content) && (
          <div className="mt-2 flex flex-wrap items-center gap-2">
            {msg.sources?.map((s) => (
              <span key={s} className="inline-flex items-center gap-1 border border-white/10 px-2 py-0.5 font-mono text-[10px] text-zinc-400">
                <FileText size={11} /> {s}
              </span>
            ))}
            {msg.content && (
              <button onClick={copy} className="p-1 text-zinc-600 opacity-0 hover:text-white group-hover:opacity-100" data-testid={`chat-copy-${index}`} style={{ transition: "opacity 160ms" }}>
                {copied ? <Check size={13} /> : <Copy size={13} />}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
